module.exports = __webpack_public_path__ + "static/antonio_-30cfef20d4182d75e760ec9e86200ba2.png";